// extracted by mini-css-extract-plugin
module.exports = {"container":"EmptySearch_container__1iqlm","title":"EmptySearch_title__3c4VN"};